import ivi from './assets/wedding-party/ivi.jpg';
import poli from './assets/wedding-party/poli.jpg';
import ani from './assets/wedding-party/ani.jpg';
import viki from './assets/wedding-party/viki.jpg';
import eli from './assets/wedding-party/eli.jpg';
import mihaela from './assets/wedding-party/mihaela.jpg';
import deni from './assets/wedding-party/deni.jpg';

import alex from './assets/wedding-party/alex.jpg';
import dimi from './assets/wedding-party/dimi.jpg';
import moretti from './assets/wedding-party/moretti.jpg';
import mariyan from './assets/wedding-party/mariyan.jpg';
import hristo from './assets/wedding-party/hristo.jpeg';
import rado from './assets/wedding-party/rado.jpg';
import gero from './assets/wedding-party/gero.jpg';
import boris from './assets/wedding-party/boris.jpg';

import kamiBaby from './assets/memories/kami-baby.JPG'
import kami2006 from './assets/memories/kami2006.jpeg';
import hristo2006 from './assets/memories/hristo2006.jpg';

import kami2011 from './assets/memories/kami2011.jpeg';
import hristo2011 from './assets/memories/hristo2011.jpg';

import beginning from './assets/memories/2015-09-20.JPG';
import image0 from './assets/memories/2015-11-1.JPG';
import image01 from './assets/memories/2016-05-17.JPG';
import image1 from './assets/memories/2016-05-22.JPG';
import image2 from './assets/memories/2016-05-22-01.jpg';
import prohodna from './assets/memories/2016-07-10.JPG';
import pancharevo from './assets/memories/2016-07-17.JPG';
import sozopol from './assets/memories/2016-08-20.JPG';
import italy from './assets/memories/2016-09-07.jpg';
import studGrad from './assets/memories/2017-12-30.jpg';
import ezera from './assets/memories/2018-07-07.jpg';
import golqma from './assets/memories/2018-11-04.jpg';
import makaron from './assets/memories/2019-02-17.jpg';
import greece from './assets/memories/2019-08-10.jpg';
import more from './assets/memories/2020-08-31.jpg';
import home from './assets/memories/2021-05-23.jpg';
import mishe from './assets/memories/2022-07-30.JPG';
import iviwedding from './assets/memories/2022-08-27.JPG';
import disney from './assets/memories/2023-05-18.jpg';
import paris from './assets/memories/2023-05-19.jpg';
import egypt from './assets/memories/2023-10-29.jpg';
import kali from './assets/memories/2020-05-12.jpg';
import london from './assets/memories/london.jpg';
import hongKong from './assets/memories/hong-kong.jpg';
import nara from './assets/memories/2024-10-27.jpg';
import netherlands from './assets/memories/netherlands.jpg';
import macedonia from './assets/memories/2018-08-05.jpg';
import serbia from './assets/memories/2019-06-25.jpg';
import belgium from './assets/memories/2022-09-22.jpg';
import germany from './assets/memories/2023-12-9.jpg';
import genderReveal from './assets/memories/gender-reveal.MOV';
import wedding from './assets/memories/2025-06-06.JPG';
import babyKoko from './assets/memories/babyKoko.jpg';

import coctail from './assets/schadule/cocktail2.png';
import ceremony from './assets/schadule/ceremony2.png';
import photos from './assets/schadule/photos.png';
import dinner from './assets/schadule/dinner.png';
import cake from './assets/schadule/cake.png';

export const BRIDESMAIDS = [
    {
        name: 'Анна Драганова',
        src: ani
    },
    {
        name: 'Виктория Димитрова',
        src: viki
    },
    {
        name: 'Деница Ватахова',
        src: deni
    },
    {
        name: 'Елена Караколева',
        src: eli
    },
    {
        name: 'Ивияна Гюрчева',
        src: ivi
    },
    {
        name: 'Михаела Христова',
        src: mihaela
    },
    {
        name: 'Полина Тодорова',
        src: poli
    },
];

export const GROOMSMEN = [
    {
        name: 'Aлександър Ванков',
        src: alex
    },
    {
        name: 'Борис Катанов',
        src: boris
    },
    {
        name: 'Геро Николов',
        src: gero
    },
    {
        name: 'Мариян Белчев',
        src: mariyan
    },
    {
        name: 'Морети Георгиев',
        src: moretti
    },
    {
        name: 'Радослав Костадинов',
        src: rado
    },
    {
        name: 'Христо Дачев',
        src: hristo
    },
];

export const SCHEDULE = [
    {
        title: '17:00',
        description: 'Коктейл',
        image: coctail,
        imageWidth: 50
    },
    {
        title: '18:00',
        description: 'Церемония',
        image: ceremony,
        imageWidth: 50
    },
    {
        title: '18:30',
        description: 'Снимки',
        image: photos,
        imageWidth: 50
    },
    {
        title: '19:00',
        description: 'Вечеря',
        image: dinner,
        imageWidth: 50
    },
    {
        title: '23:00',
        description: 'Торта',
        image: cake,
        imageWidth: 45
    },
]


export const MEMORY_LANE = [
    // {
    //     paralel: [
    //         {
    //             image: kamiBaby
    //         },
    //         {
    //             image: kamiBaby
    //         }
    //     ]
    // },
    // {
    //     title: '2004г',
    //     paralel: [
    //         {
    //             image: kami2004
    //         },
    //         {
    //         },
    //     ]
    // },
    // {
    //     title: '2005г',
    //     paralel: [
    //         {
    //             image: kami2005
    //         },
    //         {
    //         },
    //     ]
    // },
    {
        title: '2006г',
        paralel: [
            {
                image: kami2006
            },
            {
                image: hristo2006
            },
        ]
    },
    // {
    //     title: '2009г',
    //     paralel: [
    //         {
    //             image: kami2009
    //         },
    //         {
    //             image: hristo2009
    //         },
    //     ]
    // },
    // {
    //     title: "2010г",
    //     paralel: [
    //         {
    //             image: kami2010
    //         },
    //         {
    //         },
    //     ]
    // },
    {
        title: "2011г",
        paralel: [
            {
                image: kami2011
            },
            {
                image: hristo2011
            },
        ]
    },
    // {
    //     title: "2012г",
    //     paralel: [
    //         {
    //             image: kami2012
    //         },
    //         {
    //             image: hristo2012
    //         },
    //     ]
    // },
    // {
    //     title: "2013г",
    //     paralel: [
    //         {
    //             image: kami2013
    //         },
    //         {
    //             image: hristo2013
    //         },
    //     ]
    // },
    // {
    //     title: "2014г",
    //     paralel: [
    //         {
    //             image: kami2014
    //         },
    //         {
    //             image: hristo2014
    //         },
    //     ]
    // },
    // {
    //     title: "2015г",
    //     paralel: [
    //         {
    //             image: kami2015
    //         },
    //         {
    //             image: hristo2015
    //         },
    //     ]
    // },
    {
        title: "20 Септември 2015г.",
        description: "Когато Ками осъзнава, че Христо всъщност може би наистина има сериозни намерения.",
        image: beginning
    },
    {
        title: "31 Oктомври 2015г.",
        description: 'На вилата на Морети - с. Голяма желязна.',
        image: image0
    },
    {
        title: "17 Май 2016г.",
        description: 'Завършване 12 клас.',
        image: image01
    },
    {
        title: "22 Май 2016г.",
        description: 'Бал ТУЕС',
        image: image1
    },
    {
        title: "22 Май 2016г.",
        description: 'Ето как ставаме едни от победителите на танцувалното състезание по време на бала ни.',
        image: image2
    },
    {
        title: "10 Юли 2016г.",
        description: 'С компанията до пещера Проходна, една част да скачаме с бънджи.',
        image: prohodna
    },
    {
        title: "17 Юли 2016г.",
        description: 'Разходка в Панчарево',
        image: pancharevo
    },
    {
        title: "20 Август 2016г.",
        description: 'Първо море заедно в Созопол.',
        image: sozopol
    },
    {
        title: "6 Септември 2016г.",
        description: 'Първата ни екскурзия заедно - Италия с автобус от София.',
        image: italy
    },
    {
        title: "30 Декември 2017г.",
        description: 'Когато Студентски град беше мястото за сбирки',
        image: studGrad
    },
    {
        title: "7 Юли 2018г.",
        description: 'Опит да изкачим Седемте рилски езера.',
        image: ezera
    },
    {
        title: "5 Август 2018г.",
        description: 'Разходка до Македония и каньона Матка',
        image: macedonia
    },
    {
        title: "4 Ноември 2018г.",
        description: 'Отпразнуване на рождения ден на Ками, по тогавашна традиция, в Голяма Желязна',
        image: golqma
    },
    {
        title: "17 Февруари 2019г.",
        description: 'В търсене на разнообразие - майсторим Френски макарони.',
        image: makaron
    },
    {
        title: "22 Март 2019г.",
        description: 'Екскурзия до Амстердам, Холандия с Христо и Ани.',
        image: netherlands
    },
    {
        title: "25 Юни 2019г.",
        description: 'Заедно с родителите на Ками бяхме на конференция за детски играчки в Белград, Сърбия.',
        image: serbia
    },
    {
        title: "10 Август 2019г.",
        description: 'Попаднаха ни изключително евтини билети до Каламата, Гърция и се пуснахме на екскурзия.',
        image: greece
    },
    {
        title: "12 Май 2020г.",
        description: 'След няколко неуспешни опита да си купим таралежче, си взехме Кали.',
        image: kali
    },
    {
        title: "31 Август 2020г.",
        description: 'Първото ни море с Кали',
        image: more
    },
    {
        title: "23 Май 2021г.",
        description: 'В новия ни дом',
        image: home
    },
    {
        title: "28 Септември 2021г.",
        description: 'На гости на Мишето и Дими в Лондон',
        image: london
    },
    {
        title: "30 Юли 2022г.",
        description: 'На сватбата на Мишето и Дими',
        image: mishe
    },
    {
        title: "27 Август 2022г.",
        description: 'На сватбата на Иви и Гошо',
        image: iviwedding
    },
    {
        title: "22 Септември 2022г.",
        description: 'На гости на Мишето и Дими в Белгия',
        image: belgium
    },
    {
        title: "18 Май 2023г.",
        description: 'Дисни Ленд Париж',
        image: disney
    },
    {
        title: "19 Май 2023г.",
        description: 'Разходка до Париж с Мишето и Дими',
        image: paris
    },
    {
        title: "29 Октомври 2023г.",
        description: 'Екскурзия до Египет',
        image: egypt
    },
    {
        title: "9 Декември 2023г.",
        description: 'На коледен базар в Мюнхен, Германия',
        image: germany
    },
    {
        title: "23 Май 2024г.",
        description: 'Хонг Конг',
        image: hongKong
    },
    {
        title: "27 Октомври 2024г.",
        description: 'Нара, Япония - мястото на предложението',
        image: nara
    },
    {
        title: "26 Април 2025г.",
        description: "Разкрихме пола на нашето първо дете",
        video: genderReveal,
    },
    {
        title: "06 Юни 2025г.",
        description: 'На този ден сключихме граждански брак и си казахме "Да"',
        image: wedding
    },
    {
        title: "Декември 2025г.",
        description: 'Първата коледа на Коко',
        image: babyKoko
    }
];
